export enum UserAreaTabs {
  requests = '#solicitudes',
  bookings = '#reservas',
  historical = '#historico',
}

export enum RequestStatus {
  requestSend = 'REQUEST_SENT',
  requestAccepted = 'CARETAKER_AVAILABLE',
  requestRejected = 'CARETAKER_NOT_AVAILABLE',
  requestCancelled = 'CANCELLED',
  caretakerSelected = 'CARETAKER_SELECTED',
  requestAborted = 'ABORTED',
  requestPending = 'PENDING',
}



// WEBPACK FOOTER //
// ./src/views/UserArea/UserArea.model.ts